import { useEffect, useState } from "react";
import type { Order } from "@/lib/projects";
import { getProjectCustomFieldSchemas } from "@/lib/projects";
import {
  buildLabelIndexFromSchemas,
  isFixedPriceOrderType,
  resolveCustomFieldByLabels,
} from "@/pages/projekte/hoursUsage";

export function useFestpreisProject(project: Order | null | undefined): boolean {
  const [festpreisMode, setFestpreisMode] = useState(false);

  useEffect(() => {
    if (!project) {
      setFestpreisMode(false);
      return;
    }
    const appOrderType = String(project.auftragsart_app || "").trim();
    if (appOrderType) {
      setFestpreisMode(isFixedPriceOrderType(appOrderType));
      return;
    }
    let cancelled = false;
    void (async () => {
      try {
        const schemas = await getProjectCustomFieldSchemas();
        const idx = buildLabelIndexFromSchemas(schemas);
        const v = resolveCustomFieldByLabels(project, ["Auftragsart"], idx);
        if (!cancelled) setFestpreisMode(isFixedPriceOrderType(v));
      } catch {
        if (!cancelled) setFestpreisMode(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [project]);

  return festpreisMode;
}
